import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AppProvider from './providers/AppProvider';
import Overlay from './components/Overlay';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { initStyles, initAnalytics } from './utils/utils';
import './styles.css';

function App() {
  useEffect(() => {
    initStyles();
    initAnalytics();
  }, []);
  return (
    <AppProvider>
      <Router>
        <div id="app-root">
          <Overlay />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;